// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"1ce96b6a","223":"f3631d79","453":"4c5460d0","558":"4131addb","604":"16c50f45","724":"aa41c18e","798":"07df95db","833":"141d6a2f","854":"cfed9739","868":"d608b0e9","878":"b88ec8bf","929":"e9bb9fe4","932":"cda336d8","964":"35ac8549"}[chunkId] + ".chunk.js";
};